import { useMemo } from 'react'

export default function useDataTransform(props, data) {
  return useMemo(() => {
    // transform for TysiaSelectOne
    return (
      data?.map(item => ({
        id: item.appointment_type._id,
        text: item.full_name_computed,
        color_id_computed: item.color_id_computed,
        template_id: item.id,
        duration: item.duration,
        is_emergency: item.appointment_type.emergency,
      })) ?? []
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])
}
